// NOTE: NSAI-5910 — pacing for a socket whose handshake keeps being refused
// for its credentials. The first refusal is answered at once (the routine
// "access token expired" case); every later one waits, doubling from the base
// delay up to the cap, and while the app is hidden it waits for the app to be
// used again instead of on a timer.
export const SOCKET_AUTH_RETRY_BASE_DELAY_MS = 2000;
export const SOCKET_AUTH_RETRY_MAX_DELAY_MS = 5 * 60 * 1000;
